module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _c('a', {
    attrs: {
      "id": "ch1"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/contents#ich1"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("Chapter One:")])]), _vm._v(" Cakes")])]), _vm._v(" "), _c('div', {
    staticClass: "boxg1"
  }, [_c('p', {
    staticClass: "center1"
  }, [_vm._v("My love for gingerbread began with cake—nothing fancy, just a square of moist chestnut-colored goodness, stil warm from the oven and fragrant with molasses and spices, best served with a dollop of delicately sweetened, softly whipped cream. I ate slowly, waiting for the cool cream to relinquish its fluffiness to the warm gingerbread, and and I was always left with a comforting plate of saucy, sweet crumbs. Plain, straightforward gingerbread is still my favorite, but over the years, I have found other wonderful versions, too. Some are simple and modest, while others are a bit more complex and elegant. From a nineteenth-century-inspired gingerbread brightened with lemon to a gingerbread topped with walnuts and doused with rum to a ayered gingerbread filled with crunchy meringue and glossy praline buttercream, I have indeed discovered many tempting gingerbread cakes. All represent gingerbread’s delicious versatility, and remind me why I fell in love with that seductive square of spicy comfort so long ago.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _vm._v("When I was a young girl, my paternal grandmother, Hedwig Zalewski Lindner, gave me her 1950 edition of "), _c('em', [_vm._v("Betty Crocker’s New Picture Cook Book")]), _vm._v(". Among the binder-bound pages covered with my grandmother’s handwritten notes and various specks of salad dressing and butter, I discovered a recipe for Favorite Gingerbread. It was the first gingerbread prepared myself, and for years it became my staple recipe. Eventually, though, I began tinkering with it to make it my own. Substituting butter for shortening, adding a bit more spice here and there, and playing with a variety of cake pans and baking times, I soon developed my own favorite gingerbread, which I now share with you. To be honest, I really don’t know whether my grandmother ever made this gingerbread cake. It doesn’t really matter, though. To me, it is enough that this recipe originates from a book she used so often. Preparing it, like leafing through her copy of "), _c('em', [_vm._v("Betty Crocker")]), _vm._v(", reminds me of her and the many delicious, comforting dishes she prepared. This cake comes together easily and can be baked in a variety of festive pans. Bake it in an 8-cup Bundt pan, as suggested here, in a 9-inch square pan, or fill muffin tins or mini-Bundt pans about two-thirds full with batter. As you play with different shapes and sizes, just be sure to keep watch and adjust the baking times, allowing fewer minutes for smaller items.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "ch1.1"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/contents#ich1.1"
    }
  }, [_c('strong', [_vm._v("Grandmom Lindner’s Favorite Gingerbread Cake")])])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0012-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "subtitle1"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("MAKES ONE 8-CUP BUNDT CAKE")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("2½ cups cake flour")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("1 teaspoon baking soda")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("½ teaspoon salt")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("1½ teaspoons ground ginger")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("1 teaspoon ground cinnamon")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("¼ teaspoon ground allspice")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("¼ teaspoon ground cloves")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("½ cup (1 stick) unsalted butter at room temperature")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("¼ cup packed dark brown sugar")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("1 cup molasses")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("1 teaspoon vanilla extract")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("1 large egg")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("1 cup hot water")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('strong', [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch07#page_132",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Whipped Cream")]), _vm._v(" for serving (optional)")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Position a rack in the middle of the oven and preheat the oven to 350°F. Butter and flour an 8-cup Bundt pan.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Whisk together the cake flour, baking soda, salt, ginger, cinnamon, allspice, and cloves in a large bowl.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Put the butter in the bowl of an electric mixer fitted with the paddle attachment and beat on medium-high speed until smooth. Add the brown sugar and beat until light and fluffy. Pour in the molasses and beat until smooth. Add the vanilla extract, drop in the egg, and mix until incorporated, stopping at least once to scrape the sides of the bowl. Reduce the mixing speed to medium-low and alternately incorporate the flour mixture and hot water, beginning and ending with the flour mixture and stopping once or twice to scrape the sides of the bowl.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Pour the batter into the prepared pan and bake for about 45 minutes, or until a wooden skewer inserted near the center comes out clean. Set the gingerbread on a wire rack to cool in the pan for about 15 minutes before turning out to cool for about 10 minutes more.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Serve the cake warm or at room temperature, cut into wedges, and with dollops of the Whipped Cream, if desired.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _vm._v("I wanted to create a cake that not only celebrated the sweet-and-spicy qualities of old-fashioned gingerbread, but one that also featured the fine grain and density of traditional buttery pound cake. Success came rather slowly. Despite its popularity and ubiquity consistently moist, close-grained pound cake can be challenging to bake. Altering tried-and-true formulas, such as by incorporating dark brown sugar and molasses, makes the task even trickier. I do believe I found success with this version, however. Tender, rich, and buttery, it is also warm with spices and comfortingly sweet with molasses. This pound cake is so dense and satisfying that it pairs as well with a cold glass of milk at snack time as it does with a demitasse of espresso for dessert.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "ch1.2"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/contents#ich1.2"
    }
  }, [_c('strong', [_vm._v("Gingerbread Pound Cake")])])]), _vm._v(" "), _c('p', {
    staticClass: "subtitle1"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("MAKES ONE 9-BY-5-BY-3-INCH LOAF CAKE")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("2 cups cake flour")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("1 teaspoon baking powder")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("¾ teaspoon salt")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("2½ teaspoons ground ginger")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("2 teaspoons ground cinnamon")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("1 teaspoon ground cloves")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("½ teaspoon freshly grated nutmeg")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("1 cup (2 sticks) unsalted butter at room temperature")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("¾ cup granulated sugar")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("½ cup packed dark brown sugar")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("½ cup molasses")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("1½ teaspoons vanilla extract")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("5 large eggs")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Position a rack in the middle of the oven and preheat the oven to 325°F. Butter and flour a 9-by-5-by-3-inch loaf pan.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Whisk together the cake flour, baking powder, salt, ginger, cinnamon, cloves, and nutmeg in a medium bowl.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Put the butter in the bowl of an electric mixer fitted with the paddle attachment and beat on medium-high speed until smooth. Add the granulated and brown sugars and beat until light and fluffy. Pour in the molasses and beat until smooth. Add the vanilla extract and drop in the eggs, one at time, beating for about 2 minutes and stopping at least once to scrape the sides of the bowl. Reduce the mixing speed to medium-low and gradually add the flour mixture, beating just until incorporated.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Pour the batter into the prepared pan and bake for about 1 hour and 15 minutes, or until the cake is dark chestnut brown in color, the top is cracked, and a wooden skewer inserted in the center comes out clean. Set the cake on a wire rack to cool in the pan for about 15 minutes before turning out to cool completely.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Serve the pound cake cut into ¼- to ½-inch-thick slices.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _vm._v("Combining the sweet, squashy flavors of pumpkin and the spicy, molasses-rich sweetness of gingerbread, this cake represents the best of fall comfort food. More gingerbready than pumpkiny, the squash plays a supportive role in this cake. It adds moistness and sweetness to the gingerbread, as well as a delicate pumpkin flavor that supports and enhances the cake’s spicy richness. As it bakes, the gingerbread acquires a deep chestnut-colored patina and tender, moist crumb. Dark molasses lends a rich caramel flavor to the gingerbread, but if you wish to make a lighter, less intense version, simply use mild molasses instead. Although it is tempting to serve the cake warm, try to wait until it has cooled. This will prevent the sliced wedges from breaking apart and enable you to appreciate their soft texture even more.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "ch1.3"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/contents#ich1.3"
    }
  }, [_c('strong', [_vm._v("Pumpkin-Gingerbread Cake")])])]), _vm._v(" "), _c('p', {
    staticClass: "subtitle1"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("MAKES ONE 10-INCH CAKE")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("3 cups all-purpose flour")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("2 teaspoons baking powder")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("2 teaspoons baking soda")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("1 teaspoon salt")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("1 tablespoon ground ginger")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("1½ teaspoons ground cinnamon")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("½ teaspoon freshly grated nutmeg")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("½ teaspoon ground cloves")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("1 cup (2 sticks) unsalted butter at room temperature")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("1 cup granulated sugar")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("¼ cup packed light brown sugar")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("½ cup dark molasses")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("4 large eggs")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("2 teaspoons vanilla extract")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("2¼ cups pumpkin purée")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("2 tablespoons finely chopped crystallized ginger")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('strong', [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch07#page_134",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vanilla Ice Cream")]), _vm._v(" for serving (optional)")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Position a rack in the middle of the oven and preheat the oven to 350°F. Butter and flour a 10-inch tube pan.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Whisk together the flour, baking powder, baking soda, salt, ginger, cinnamon, nutmeg, and cloves in a large bowl.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Put the butter in the bowl of an electric mixer fitted with the paddle attachment and beat on medium-high speed until smooth. Add the granulated and brown sugars and beat until light and fluffy. Pour in the molasses and beat until smooth. Drop in the eggs, one at time, and beat for about 2 minutes, stopping at least once to scrape the sides of the bowl. Add the vanilla extract, pumpkin purée, and crystallized ginger, mixing until combined. Reduce the mixing speed to medium-low and gradually add the flour mixture, beating just until incorporated.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Pour the batter into the prepared pan and bake for about 1 hour, or until the cake is dark chestnut brown in color, the top is cracked, and a wooden skewer inserted near the center comes out clean. Set the cake on a wire rack to cool in the pan for about 15 minutes before turning out to cool completely.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Serve the cake cut into wedges and with the Vanilla Ice Cream, if desired.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _vm._v("There is something so approachable and delightfully old-fashioned about simply frosted layer cakes. This apple-enriched gingerbread version is no exception. Apple butter not only lends moistness to the cake, but its caramelized, slightly tart flavor also complements the warm spiciness of the gingerbread. Buttery and packed with brown sugar, the butterscotch-flavored, slightly (and delightfully) grainy frosting marries deliciously with these tender layers and is easy to apply as well. No professional cake turntable or special pastry palette knife is required here. The frosting is simply spread on the top of each layer, keeping the sides of the cake open to reveal its gorgeously dark amber color.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "ch1.4"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/contents#ich1.4"
    }
  }, [_c('strong', [_vm._v("Apple Butter-Gingerbread Cake")])])]), _vm._v(" "), _c('p', {
    staticClass: "subtitle2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("WITH BROWN SUGAR FROSTING")])]), _vm._v(" "), _c('p', {
    staticClass: "subtitle1"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("MAKES ONE 9-INCH LAYER CAKE")])]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("CAKE")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("2¾ cups all-purpose flour")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("¾ cup granulated sugar")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("¼ cup packed dark brown sugar")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("2 teaspoons ground ginger")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("1½ teaspoons ground cinnamon")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("1 teaspoon ground allspice")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("1 teaspoon freshly grated nutmeg")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("½ teaspoon salt")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("1 cup (2 sticks) unsalted butter at room temperature")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("1 cup buttermilk")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("l¼ teaspoons baking soda")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("1 teaspoon vanilla extract")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("5 large eggs")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("1 cup Apple Butter (recipe follows) or store-bought apple butter")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("½ cup finely chopped crystallized ginger")])]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("BROWN SUGAR FROSTING")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("¾ cup packed dark brown sugar")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("½ cup (1 stick) unsalted butter at room temperature")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("4 cups confectioners’ sugar")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("¼ teaspoon salt")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("¼ cup whole milk")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("1 teaspoon vanilla extract")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Position two racks in the middle of the oven and preheat the oven to 350°F. Butter and flour three 9-by-2-inch or 9-by-1-inch round cake pans.")]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("TO MAKE THE CAKE")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent4"
  }, [_vm._v("Combine the flour, granulated and brown sugars, ginger, cinnamon, allspice, nutmeg, and salt in the bowl of an electric mixer fitted with the paddle attachment and begin mixing on medium-low speed. Add the butter, about 2 tablespoons at a time, increase the mixing speed to medium, and continue beating until the mixture resembles the texture of fine bread crumbs. Stir together the buttermilk and baking soda in a small bowl and gradually pour into the beating mixture. Add the vanilla extract and drop in the eggs, one at a time, beating until smooth and stopping once or twice to scrape the sides of the bowl. Increase the mixing speed to medium-high and beat until light and fluffy. Reduce the speed again to medium and add the Apple Butter and crystallized ginger, mixingjust until incorporated.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Divide the batter among the prepared pans and bake for 20 to 25 minutes, or until a wooden skewer inserted in the centers comes out clean. Set the cakes on wire racks to cool in the pans for about 10 minutes before turning out to cool completely.")]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("TO MAKE THE FROSTING")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent4"
  }, [_vm._v("Combine the brown sugar and butter in the bowl of an electric mixer fitted with the paddle attachment and beat on medium-high speed until very light and fluffy. Reduce the mixing speed "), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _vm._v("to low, gradually add the confectioners’ sugar and salt, and beat until the mixture is crumbly, stopping once or twice to scrape the sides of the bowl. Pour in the milk and vanilla extract, increase the mixing speed to high, and beat until light and fluffy.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Set one of the cakes on a cake plate and spread one-third of the frosting on top. Repeat the layering process in the same order two more times, finishing with frosting on top.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Serve the cake cut into wedges or about ½-inch-thick square pieces.")]), _vm._v(" "), _c('div', {
    staticClass: "boxb1"
  }, [_c('h3', {
    staticClass: "h3a"
  }, [_c('strong', [_vm._v("Apple Butter")]), _c('br'), _c('span', {
    staticClass: "small"
  }, [_vm._v("MAKES ABOUT 3 CUPS")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("3 pounds (about 8 medium) apples (such as Gala or Granny Smith), peeled, cored, and roughly chopped")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("1 cup apple cider")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("Juice of 1 lemon")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("1 teaspoon grated lemon zest")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("1¼ cups packed light or dark brown sugar")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("2 teaspoons ground cinnamon")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("1 teaspoon ground ginger")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("¾ teaspoon ground allspice")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("¼ teaspoon ground cloves")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("¼ teaspoon salt")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Stir together the apples, cider, and lemon juice in a large saucepan. Partially cover the pan and cook over medium-low heat, stirring occasionally, for about 30 minutes, or until the apples are softened.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Purée the cooked apples in a blender, food mill, or in the pan with an immersion blender. Return the purée to the saucepan (if necessary), add the remaining ingredients, and cook over very low heat, stirring occasionally, for about 1½ to 2 hours, or until the apple butter is dark and very thick. The butter is done when pulling a wooden spoon through it creates a distinct path that fills in slowly.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Spoon the hot butter into sterilized jars, seal, and set on a wire rack to cool. Put the butter in the refrigerator for at least several days before using so that the flavors blend and soften. Store the apple butter in the refrigerator for up to 3 months.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _vm._v("Pears and gingerbread make for a perfect match. Each puts us in mind of fall’s comforting aromas and flavors, and when combined, the sweet, juicy fruit naturally complements the moist, spicy gingerbread. Perhaps the loveliest thing about upside-down cake is that it can be as informal or dressy a dessert as you wish. Inherently warming and comforting, it is also dazzlingly pretty; this fruited gingerbread is sure to become a new way to enjoy an old favorite.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "ch1.5"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/contents#ich1.5"
    }
  }, [_c('strong', [_vm._v("Spiced Pear Upside-Down Gingerbread Cake")])])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0018-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "subtitle1"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("MAKES ONE 9-HNTCH CAKE")])]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("PEARS")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("½ cup packed light brown sugar")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("2 teaspoons ground cinnamon")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("1 teaspoon ground ginger")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("2 tablespoons unsalted butter, melted")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("3 medium Bosc pears, peeled, cored, and cut lengthwise into ¼-inch-thick slices")])]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("CAKE")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("1⅓ cups all-purpose flour")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("1 teaspoon salt")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("2 teaspoons baking powder")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("¼ teaspoon baking soda")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("1½ teaspoons ground ginger")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("1½t easpoons ground cinnamon")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("6 tablespoons unsalted butter at room temperature")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("⅓ cup packed dark brown sugar")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("½ cup molasses")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("1 large egg")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("½ cup whole milk")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('strong', [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch07#page_134",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vanilla Ice Cream")]), _vm._v(" for serving (optional)")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Position a rack in the middle of the oven and preheat the oven to 350°F. Butter a 9-by-2-inch round cake pan.")]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("TO PREPARE THE PEARS")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent4"
  }, [_vm._v("Stir together the brown sugar, cinnamon, and ginger in a medium bowl. Spread the melted butter evenly over the bottom of the prepared pan and sprinkle the sugar mixture evenly on top. Arrange the pear slices in a decorative concentric circle pattern over the sugar mixture.")]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("TO MAKE THE CAKE")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent4"
  }, [_vm._v("Whisk together the flour, salt, baking powder, baking soda, ginger, and cinnamon in a large bowl.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Put the butter in the bowl of an electric mixer fitted with the paddle attachment and beat on medium-high speed until smooth. Add the brown sugar and beat until light and fluffy.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Pour in the molasses and beat until smooth. Drop in the egg and mix until incorporated, stopping at least once to scrape the sides of the bowl. Reduce the mixing speed to medium-low and alternately incorporate the flour mixture and milk, beginning and ending with the flour mixture and stopping once or twice to scrape the sides of the bowl. Increase the speed to medium-high and beat until smooth.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Pour the cake batter over the pears and set the pan on a baking sheet. Bake for 40 to 45 minutes, or until the cake is chestnut brown in color and a wooden skewer inserted in the center comes out clean. Set the cake on a wire rack to cool in the pan for 10 to 15 minutes. Run a paring knife around the edges of the cake to loosen them a bit, invert it onto a serving plate, and carefully lift off the pan.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Serve the cake warm or at room temperature cut into wedges and with the Vanilla Ice Cream, if desired.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _vm._v("My maternal grandmother, Adelaide Walls Fighera, had a wicked sweet tooth, but I don’t remember her baking much. ce cream was more her style, as I recall. She did, however, make one annual pilgrimage to the oven. Every Christmas, she baked a rum cake. My mother purchased the ingredients for this cake as we awaited my grandparents’ arrival from Florida. The yellow cake mix, butter, a bottle of rum, and chopped walnuts were waiting on the kitchen counter for Mom-Mom when she arrived. We started baking on Christmas Eve. The cake part was pretty straightforward. It was when we prepared the rum syrup, though, that things became a little foggy. When the cake came out of the oven, she began preparing the syrup by melting butter, sugar, and rum in a small pot on the stove. We stirred and tasted, and tasted, and tasted, each time declaring how delicious it was, and improving it every so often with another slosh of rum. By the time we were ready to poke holes in the cake to prepare it for the syrup, we were so full of buttery alcohol that I’m not really sure how we ever succeeded in doing so without skewering ourselves. Somehow I guess we did, though. I can still see the glistening syrup-soaked cake proudly displayed on the sideboard in the dining room. This gingerbread rum cake takes its cue from Mom-Mom’s yellow cake-based creation. It is just as rich, buttery, and moist, but it becomes more delicate and fragrant with the addition of nutmeg and ground and crystallized gingers. The rum syrup hasn’t changed too much, so proceed with caution as you taste it.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "ch1.6"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/contents#ich1.6"
    }
  }, [_c('strong', [_vm._v("Gingerbread Rum Cake")])])]), _vm._v(" "), _c('p', {
    staticClass: "subtitle1"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("MAKES ONE 10-INCH CAKE")])]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("CAKE")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("3 cups all-purpose flour")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("2 teaspoons baking powder")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("1 teaspoon salt")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("1 tablespoon ground ginger")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("½ teaspoon freshly grated nutmeg")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("1 cup (2 sticks) unsalted butter at room temperature")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("2 cups sugar")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("4 large eggs")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("1½ teaspoons vanilla extract")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("½ cup whole milk")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("½ cup light or dark rum")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("¼ cup finely chopped crystallized ginger")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("¾ cup toasted walnuts, chopped")])]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("RUM SYRUP")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("¼ cup (½ stick) unsalted butter")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("½ cup sugar")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("6 tablespoons light or dark rum")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Position a rack in the middle of the oven and preheat the oven to 350°F. Butter and flour a 10-inch tube pan.")]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("TO MAKE THE CAKE")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent4"
  }, [_vm._v("Whisk together the flour, baking powder, salt, ginger, and nutmeg in a large bowl.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Put the butter in the bowl of an electric mixer fitted with the paddle attachment and beat on medium-high speed until smooth. Add the sugar and beat until light and fluffy. Drop in the eggs, one at time, beating until light and smooth and stopping at least once to scrape the sides of the bowl. Stir together the vanilla extract, milk, and rum in a small bowl. Reduce the mixing speed to medium-low and alternately incorporate the flour and "), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _vm._v("milk mixtures, beginning and ending with the flour mixture and stopping once or twice to scrape the sides of the bowl. Add the crystallized ginger and mix just until combined.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Sprinkle the walnuts into the prepared pan, covering the bottom evenly. Pour the batter over the walnuts and bake for about 1 hour, or until the cake is golden brown, the top is cracked, and a wooden skewer inserted near the center comes out clean. Set the cake on a wire rack to cool in the pan for about 15 minutes before turning out to cool for about 10 minutes more, walnut-side up.")]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("MEANWHILE, MAKE THE RUM SYRUP")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent4"
  }, [_vm._v("Combine the butter and sugar in a small saucepan and cook over medium heat, stirring occasionally, until the butter is melted and the sugar is dissolved. Remove from the heat and stir in the rum.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Place a large baking sheet or sheet of aluminum foil under the rack. Using a wooden skewer or toothpick, poke holes all over the top of the cake. (You can poke into the cake about 3 inches or so.) While the cake is still warm, gradually spoon the warm rum syrup over the top, allowing it to drizzle down the sides and absorb into the cake.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Serve the cake warm or at room temperature cut into wedges.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _vm._v("My friend Susan believes that pound cake is the perfect dessert solution for virtually every occasion. She happily fiddles with her pound cake recipe so often, in fact, that she is prepared to share her delicious cakes with lucky and ever-so-appreciative friends and family just about all the time. Susan generously shared the recipe for her moist, buttery creations with me, and these charming mini-Bundt gingerbread cakes are the result of my own tinkering with her master list of ingredients. The cakes are also reminiscent of the golden-colored, delicately spiced gingerbreads that appear in many eighteenth- and nineteenth-century cookery books. Unlike their darker molasses- and treacle-rich counterparts, these early cakes were often sweetened with sugar; spiced with ginger, nutmeg, mace, and caraway seeds; and perfumed with rosewater and citrus. Moist and soft, yet pleasantly dense, this recipe takes well not only to the individual Bundt form, but also to the infusion of warm spices and bright lemon. The syrup, also flavored with ginger and lemon, further flavors the gingerbreads with the vibrant, complementary sensations of heat and tartness. It makes them even more deliciously moist as well. These cakes have little need for additional embellishment. If you’d like, however, a dollop of soft whipped cream pairs with them quite nicely.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "ch1.7"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/contents#ich1.7"
    }
  }, [_c('strong', [_vm._v("Ginger Syrup-Soaked Gingerbread Cakes")])])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0022-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "subtitle1"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("MAKES 8 MINI-BUNDT CAKES")])]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("CAKES")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("2 cups cake flour")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("1 teaspoon baking powder")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("¾ teaspoon salt")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("1 tablespoon ground ginger")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("1 teaspoon ground cinnamon")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("½ teaspoon freshly grated nutmeg")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("1 cup (2 sticks) unsalted butter at room temperature")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("1 cup sugar")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("3 large eggs")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("6 tablespoons whole milk Grated zest of 1 lemon")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("½ teaspoon lemon extract or oil")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("¼ cup finely chopped crystallized ginger")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("2 tablespoons grated peeled fresh ginger")])]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("SYRUP")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("½ cup sugar")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("¼ cup water")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("Juice of 1 lemon")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("⅓ cup finely chopped peeled fresh ginger")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('strong', [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch07#page_132",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Whipped Cream")]), _vm._v(" for serving (optional)")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Position a rack in the middle of the oven and preheat the oven to 325°F. Butter and flour eight 8-ounce mini-Bundt cake cups and set them on a baking sheet. (Mini-Bundt pans usually contain 6 individual cups.)")]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("TO MAKE THE CAKES")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent4"
  }, [_vm._v("Whisk together the cake flour, baking powder, salt, ginger, cinnamon, and nutmeg in a medium bowl.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Put the butter in the bowl of an electric mixer fitted with the paddle attachment and beat on medium-high speed until smooth. Add the sugar and beat until light and fluffy. Drop in "), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }), _vm._v("the eggs, one at time, and beat for about 2 minutes, stopping at least once to scrape the sides of the bowl. Stir together the milk, lemon zest, lemon extract, and crystallized and fresh gingers in a small bowl. Pour the milk mixture into the batter, mixing until combined. Reduce the mixing speed to medium-low and gradually add the flour mixture, beating just until incorporated.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Divide the batter among the prepared Bundt cake cups. Bake for 25 to 30 minutes, or until the cakes are golden brown, puffed, and a wooden skewer inserted near the centers comes out clean.")]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("MEANWHILE, MAKE THE SYRUP")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent4"
  }, [_vm._v("Combine the sugar, water, lemon juice, and ginger in a small saucepan. Bring to a simmer over medium heat, stirring occasionally until the sugar is dissolved. Remove from the heat and set aside, keeping warm.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Set the cakes on a wire rack to cool in the pans for about 10 minutes before turning out onto the rack. Place a large baking sheet or sheet of aluminum foil under the rack. While the cakes are still warm, gradually spoon the warm syrup over the tops, allowing it to absorb completely. Set aside to cool.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Serve the cakes with the Whipped Cream, if desired.")]), _vm._v(" "), _c('div', {
    staticClass: "boxb1"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Eighteenth- and early-nineteenth-century recipes often called for liquor, and did so as well in the case of blond gingerbreads. If early cookery books are any indication, sack—a white wine imported from Spain and the Canary Islands—seems to have been quite a popular addition.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }), _vm._v("Gingerbread and almond cake rank equally high in the category of unpretentious comforting cakes. When the two batters are swirled together into one loaf, the result is a cake that combines the best of both. Each slice is uniquely and prettily marbled with blond and chestnut-colored waves. With each bite, we experience the delicate nuttiness of almond and the complementary gentle warmth of spices and molasses. The cake has a surprisingly soft texture and delicate crumb, so you will want to cut it into generous slices, about ½ inch thick. Not too sweet or rich, this cake is as delicious for breakfast or tea as it is for dessert.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "ch1.8"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/contents#ich1.8"
    }
  }, [_c('strong', [_vm._v("Marbled Gingerbread-Almond Loaf Cake")])])]), _vm._v(" "), _c('p', {
    staticClass: "subtitle1"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("MAKES ONE 9-BY-5-BY-3-INCH LOAF CAKE")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("1¼ cups cake flour")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("¾ cup almond flour (almond meal)")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("2 teaspoons baking powder")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("½ teaspoon salt")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("½ cup (1 stick) unsalted butter at room temperature")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("¾ cup granulated sugar")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("¼ cup packed light brown sugar")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("2 large eggs")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("¾ cup whole milk")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("½ teaspoon almond extract")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("¼ cup dark molasses")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("1½ teaspoons ground ginger")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("1 teaspoon ground cinnamon")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("½ teaspoon ground cloves")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Position a rack in the middle of the oven and preheat the oven to 350°F. Butter and flour a 9-by-5-by-3-inch loaf pan.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Whisk together the cake flour, almond flour, baking powder, and salt in a medium bowl.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Put the butter in the bowl of an electric mixer fitted with the paddle attachment and beat on medium-high speed until smooth. Add the granulated and brown sugars and beat until light and fluffy. Drop in the eggs, one at a time, and beat for about 2 minutes, stopping at least once to scrape the sides of the bowl. Reduce the mixing speed to medium-low and alternately incorporate the flour mixture and milk, beginning and ending with the flour mixture and stopping once or twice to scrape the sides of the bowl.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Remove half of the batter to a medium bowl and stir in the almond extract. Stir the molasses, ginger, cinnamon, and cloves into the remaining half of the original batter.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Drop large dollops of each batter into the prepared loaf pan. (This doesn’t have to be pretty; haphazard placement is okay.) Using a wooden skewer or paring knife, swirl the batters together to produce a marbled effect. Tap the pan lightly once or twice on the work surface to remove any air bubbles. Bake for 50 to 55 minutes, or until a wooden skewer inserted in the center comes out clean. Set the cake on a wire rack to cool in the pan for 10 to 15 minutes before turning out to cool completely.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Serve the cake cut into thick (about ½-inch) slices.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }), _vm._v("My husband and I were married five days before Christmas. I had already decided I wanted a gingerbread wedding cake when we began talking with renowned pastry chef and friend Robert Bennett. He had kindly offered to prepare the cake for us, and when I suggested including apricot jam, meringue, and praline buttercream between the layers, he happily approved. Needless to say, Robert’s cake was the best wedding cake I’ve ever eaten. It was as stunning as it was delicious, standing four tiers high, covered in seamless white fondant, and decorated with sparkling sugar snowflakes. My version of Robert’s inspiring creation includes nearly all of the tasty elements our wedding guests enjoyed. The gingerbread cake is vibrantly spicy, as well as soft and delicate in texture. It’s no wonder it marries beautifully with crisp layers of meringue, sweet apricot jam, and velvety smooth buttercream. Decorate the cake with fresh flowers or with piped buttercream rosettes, gold dragées, and colorful coarse sugar, as I have done here. If you wish to celebrate with this cake in the wintertime, as my husband and I did, you might want to spend some extra time making royal icing snowflakes similar to those that decorated our wedding cake. Having prepared this cake once during a summer heat wave, I can tell you that (shocker!) royal icing snowflakes don’t like hot weather. In fact, they will downright rebel if you force them to hold their delicate shapes on a humid day. In any event, I have included directions here for making them in case you do want to try your hand at these lacy white lovelies during the cold-weather months they like best.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "ch1.9"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/contents#ich1.9"
    }
  }, [_c('strong', [_vm._v("Robert’s Celebration Gingerbread Cake")])])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0026-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "subtitle1"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("MAKES ONE 9-INCH LAYER CAKE")])]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("MERINGUE ROUNDS")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("⅔ cup almond flour (almond meal)")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("1½ tablespoons cornstarch")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("¼ teaspoon salt")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("4 large egg whites (about ½ cup)")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("1 cup sugar")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("½ teaspoon vanilla extract")])]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("CAKE")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("2½ cups all-purpose flour")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("½ teaspoon salt")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("1 tablespoon ground ginger")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("2 teaspoons ground cinnamon")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("1 teaspoon ground allspice")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("1 teaspoon ground cloves")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("½ teaspoon freshly grated nutmeg")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("½ cup (1 stick) unsalted butter at room temperature")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("½ cup packed light brown sugar")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("1 cup molasses")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("2 large eggs")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("½ cup hot water")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("½ cup brewed espresso or strong coffee")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("2 teaspoons baking soda")])]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("PRALINE BUTTERCREAM")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("7 cups (1 recipe) "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch07#page_135",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dede’s Italian Buttercream")]), _vm._v(" at room temperature")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("3 tablespoons praline paste")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("1 cup apricot jam or preserves")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("Orange and pink coarse sanding or decorating sugar for sprinkling (optional)")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("Gold dragées for decorating (optional)")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("Royal Icing Snowflakes (recipe follows) for decorating (optional)")])]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }), _c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("TO MAKE THE MERINGUE ROUNDS")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent4"
  }, [_vm._v("Position a rack in the middle of the oven and preheat the oven to 200°F. Line a large baking sheet with parchment paper. Using a 9-inch round pan, trace two 9-inch circles onto the parchment. Invert the parchment so the markings are on the opposite side but still visible.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Whisk together the almond flour, cornstarch, and salt in a small bowl.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Put the egg whites in the bowl of an electric mixer fitted with the whisk attachment and whip on high speed until frothy. Gradually incorporate the sugar, add the vanilla extract, and whip to stiff, glossy peaks.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Using a rubber spatula, fold in the almond flour mixture, about one-third at a time, working gently but quickly so as not to deflate the meringue. Divide the meringue evenly between the two circles traced onto the parchment, spreading evenly to the edges.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Bake the meringue rounds for about 1 hour, or until they are firm and very light golden brown. Set the meringues on a wire rack to cool completely on the baking sheet.")]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("TO MAKE THE CAKE")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent4"
  }, [_vm._v("Position two racks in the middle of the oven and increase the oven temperature to 350°F. Butter and flour three 9-by-2-inch round cake pans.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Whisk together the flour, salt, ginger, cinnamon, allspice, cloves, and nutmeg in a large bowl.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Put the butter in the bowl of an electric mixer fitted with the paddle attachment and beat on medium-high speed until smooth. Add the brown sugar and beat until light and fluffy. Pour in the molasses and beat until smooth. Drop in the eggs, one at time, mixing until incorporated and stopping at least once to scrape the sides of the bowl. Stir together the hot water, espresso, and baking soda in a small bowl. Reduce the mixing speed to medium-low and alternately incorporate the flour and espresso mixtures, beginning and ending with the flour mixture and stopping once or twice to scrape the sides of the bowl. Increase the mixing speed to medium-high and beat until smooth.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Divide the batter among the prepared pans and bake for 18 to 20 minutes, or until a wooden skewer inserted in the centers comes out clean. Set the gingerbread on wire racks to cool in the pans for about 10 minutes before turning out to cool completely.")]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("TO MAKE THE PRALINE BUTTERCREAM")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent4"
  }, [_vm._v("Put the buttercream in the bowl of an electric mixer fitted with the whisk attachment and whip on medium-high speed until smooth and glossy. Put the praline paste in a medium bowl. Add ½ cup of the buttercream and, using a wire whisk, whip until combined. Whisk in another 2 cups of the buttercream until smooth. Reserve the remaining plain buttercream for frosting the cake.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Place one of the gingerbread cakes on a cake plate (or on a 9-inch cardboard cake round if you plan to move the cake to another platter). Using an icing spatula or wide dinner knife, spread about one-third of the apricot jam over the top. Cover the jam with about one-quarter of the praline buttercream, set a meringue round on top, and spread about another one-quarter of the praline buttercream over it. Spread another one-third of jam over the buttercream and set a second gingerbread cake on top. Continue the layering process with the same quantities in this manner: buttercream, meringue round, buttercream, jam, gingerbread cake.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Cover the cake with a crumb coating of plain buttercream by first putting a dollop of buttercream in the center of the cake. Using an icing spatula or wide dinner knife, spread the buttercream evenly over the top to the edges. (If it starts to hang over the edges, that’s okay, and actually makes the process easier.) Scoop some additional buttercream onto the spatula. Holding it vertically and parallel to the cake with your hand positioned slightly above the top of the cake, spread the buttercream around the sides, scooping up more buttercream as needed. "), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }), _vm._v("(This coating is meant to be thin. Don’t worry if you can still see the cake layers.) Smooth the ridge that forms around the top edges by holding the spatula horizontally and at a slight angle and carefully swiping it from the edges toward the center of the cake. Set the cake in the refrigerator until the buttercream is fairly firm, about 20 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Use the same procedure for the crumb coating to cover the chilled cake with a final coating of buttercream, but make the dollop on top a bit bigger and be more generous with the buttercream you scoop onto the spatula to spread around the sides. Don’t worry if the cake isn’t smooth the first time; keep working with it and add more buttercream until you’re satisfied. Reserve about ¾cup of the buttercream for the piped decoration. Sprinkle the orange and pink sugar over the top of the cake, if desired. Fill a piping bag fitted with a rosette tip (a Number 24 tip makes a pretty little rosette) with the reserved buttercream. Pipe rosettes of buttercream around the sides and the top edges of the cake and set a gold dragée in the middle of each rosette, if desired. Store any leftover buttercream in an airtight container in the refrigerator for up to 2 weeks or in the freezer for up to 3 months.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Serve the cake cut into about ½-inch-thick wedges or square pieces.")]), _vm._v(" "), _c('div', {
    staticClass: "boxb1"
  }, [_c('h3', {
    staticClass: "h3a"
  }, [_c('strong', [_vm._v("Royal Icing Snowflakes")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("Lemon juice, egg whites, or water for thinning the icing")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("1 cup "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch07#page_136",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Royal Icing")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("Coarse, sanding, or decorating sugar for sprinkling (optional)")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch07#page_135",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dede’s Italian Buttercream")]), _vm._v(" for attaching the snowflakes")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Trace the outline of snowflake cookie cutters onto a sheet of parchment paper. Drizzle enough lemon juice into the royal icing, if necessary, to make the icing thin enough to pipe an outline. (The consistency should resemble rich sour cream. It needs to be thick enough so the snowflakes hold their shapes and resist breaking when dry.) Using a pastry bag fitted with a small round tip (a Number 4 tip is fine here), pipe the icing around the snowflake outlines. Pipe additional lines as you wish to make a lacy design, sprinkle with coarse sugar (if desired), and set aside to dry in a cool, dry area for at least 4 hours or overnight. (The snowflakes will dry more slowly on a hot and even slightly humid day.)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Carefully peel the snowflakes off of the parchment and attach them to the cake, using buttercream.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }), _vm._v("This cake is named for my mother, not because she prepares it, but, rather, because she can’t help but practically inhale it every time I make it. To be honest, I am as fond of fruitcake as she is, and we are both fairly discerning connoisseurs. Not just any fruitcake will do. It has to be warmly spiced with the likes of ginger, cinnamon, nutmeg, and cloves; sweet and dark with brown sugar; and moist with the jewel-colored fruit we like best: raisins, dried cranberries, apricots, dates, prunes, and candied citrus peel. A generous splash of whiskey or rum doesn’t hurt, either. As is traditional with fruitcake, we generally like to further contribute to the uninhibited, fervent nature of this cake by dousing it with more of the fiery stuff for at least several weeks after it is baked. It is by no means required, but covering the fruitcake with a smooth, white fondant cloak makes for a lovely finish and presentation. Actually, the cake is first brushed with apricot jam, then covered with a thin sheet of marzipan, and finally enrobed in rolled fondant. These layers not only add flavor and texture, but with the cake stored in a cool area, they help to preserve it for at least three weeks, as well.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "ch1.10"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/contents#ich1.10"
    }
  }, [_c('strong', [_vm._v("Carol Lee’s Jeweled Gingerbread Fruitcake")])])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0030-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "subtitle1"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("MAKES ONE 9-INCH CAKE")])]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("FRUITCAKE")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("2 cups all-purpose flour")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("½ cup almond flour (almond meal)")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("½ teaspoon salt")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("2 teaspoons ground ginger")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("1 teaspoon ground cinnamon")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("½ teaspoon freshly grated nutmeg")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("½ teaspoon ground cloves")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("3 cups dark raisins")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("1 cup golden raisins")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("1 cup dried cranberries")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("1 cup lightly packed dried pitted apricots, chopped")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("1 cup lightly packed dried pitted dates, chopped")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("½ cup lightly packed pitted prunes, chopped")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("¼ cup chopped "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch07#page_138",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Candied Orange Peel")]), _vm._v(" or store-bought candied orange peel")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("¼ cup chopped "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch07#page_138",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Candied Lemon Peel")]), _vm._v(" or store-bought candied lemon peel")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("½ cup whiskey or dark rum, plus more for brushing the baked cake")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("1 cup (2 sticks) unsalted butter at room temperature")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("1¼ cups packed dark brown sugar")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("5 large eggs")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("¼ cup apricot jam or preserves")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("Grated zest of 1 lemon")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("Grated zest of 1 orange")])]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("FINISHES")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("⅓ cup apricot jam or preserves")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("Confectioners’ sugar for rolling")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("9 to 10 ounces marzipan (available in most supermarkets)")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("Cornstarch for rolling")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("1½ pounds rolled fondant (available in craft and cake-decorating stores)")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("Silver dragées for decorating (optional)")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('strong', [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch07#page_133",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Crème Anglaise")]), _vm._v(" for serving (optional)")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }), _vm._v("Position a rack in the middle of the oven and preheat the oven to 300°F. Butter a 9-by-3-inch springform pan. (A nonstick pan is helpful here.) Line the bottom with a round of parchment, and butter and flour the parchment and sides of the pan.")]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("TO MAKE THE FRUITCAKE")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent4"
  }, [_vm._v("Whisk together the flour, almond flour, salt, ginger, cinnamon, nutmeg, and cloves in a medium bowl. Set aside. Toss together the raisins, cranberries, apricots, dates, prunes, candied orange and lemon peels, and ½ cup whiskey in a large bowl.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Put the butter in the bowl of an electric mixer fitted with the paddle attachment and beat on medium-high speed until smooth. Add the brown sugar and beat until light and fluffy. Drop in the eggs, one at time, and beat for about 2 minutes, stopping at least once to scrape down the sides of the bowl. Mix in the jam and the lemon and orange zests. Reduce the mixing speed to medium-low and gradually add the flour mixture, beating just until incorporated. Add the dried fruit mixture, about one-quarter at a time, mixing just until the fruit is evenly distributed throughout the batter.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Pour the batter into the prepared pan. Wrap the pan with a parchment collar that rises about 3 inches above the pan and secure with kitchen twine. Set the filled pan on a baking sheet and bake for about 2 hours, or until the cake is dark chestnut brown in color, the top is slightly cracked, and a wooden skewer inserted in the center comes out clean (a few sticky crumbs are okay, too).")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Set the cake on a wire rack to cool for about 30 minutes in the pan before turning out to cool completely. Brush with whiskey (about ¼ cup will do for now) and wrap the fruitcake in plastic wrap. Store the cake for at least 3 weeks in an airtight container, dousing it with about ¼ cup of whiskey at least once a week. You can serve the cake at this point or proceed with the method for covering the cake with fondant.")]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("TO FINISH THE FRUITCAKE")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent4"
  }, [_vm._v("Set the cake on a parchment-lined baking sheet. (If you find that the top of the cake is very bumpy, invert the cake so the smooth side faces up. A slightly lumpy top has never really bothered me, though.) Push the apricot jam through a strainer into a small bowl to remove the apricot bits and discard them. Brush the jam all over the cake. Lightly dust a work surface with confectioners’ sugar, roll the marzipan to about "), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f1by16.jpg"
    }
  }), _vm._v(" inch thick (very thin), and cut out a 14-inch-diameter circle. Carefully roll the marzipan over the rolling pin and unroll it on top of the fruitcake, smoothing it over the top and down the sides to remove any air bubbles or bumps. Trim any excess marzipan from the bottom of the cake to make a clean edge.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Clean the work surface and lightly dust it with cornstarch. Roll the fondant to ¼ inch thick and cut out a 14-inch-diameter circle. Carefully pick up the fondant circle from underneath with both hands as though carrying a tray (you can’t roll the fondant, as it will stick to itself). Place the fondant over the marzipan-covered fruitcake, again smoothing the top and sides. Trim any excess fondant from the bottom of the cake to make a clean edge. If desired, cut decorative shapes out of the remaining fondant, dampen with water, and apply onto the covered cake. Finish by pressing silver dragées (if desired) into the fondant.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Serve the cake immediately cut into thin wedges or squares with Crème Anglaise, if desired. To store the cake, wrap it in plastic wrap and set it in the refrigerator or in a cool, dry area for up to 3 weeks.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }), _vm._v("This gingerbread is, as you can guess, a cross between an old-fashioned chocolate cake and a traditional spicy gingerbread. Properly mixing ingredients is particularly important for this gingerbread, given that the batter is so rich in sugar, molasses, and chocolate. Employing the two-stage method is best here. This is an easy procedure in which the dry ingredients are combined, the butter is incorporated, and then the liquid and eggs are beaten into the batter until it is smooth and light. The result is cake that is not only rich and complex in flavor, but also surprisingly delicate, tender, and comfortingly moist.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "ch1.11"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/contents#ich1.11"
    }
  }, [_c('strong', [_vm._v("Rich Chocolate Gingerbread")])])]), _vm._v(" "), _c('p', {
    staticClass: "subtitle1"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("MAKES ONE 9-INCH CAKE")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("4 ounces semisweet or bittersweet chocolate, chopped")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("½ cup Dutch-process cocoa powder")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("1½ cups hot water")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("2¼ cups cake flour")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("1 cup packed dark brown sugar")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("1 teaspoon baking soda")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("1 teaspoon baking powder")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("½ teaspoon salt")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("2 teaspoons ground ginger")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("1½ teaspoons ground cinnamon")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("¼ teaspoon freshly grated nutmeg")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("¼ teaspoon ground cloves")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("¾ cup (1½ sticks) unsalted butter at room temperature")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("1½ teaspoons vanilla extract")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("3 large eggs")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("1 cup molasses")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('strong', [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch07#page_134",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vanilla Ice Cream")]), _vm._v(" for serving (optional)")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Position a rack in the middle of the oven and preheat the oven to 350°F. Butter and flour a 9-by-2-inch square baking pan.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Put the chocolate in a small, heatproof bowl. Set the bowl over a saucepan filled with about 1½ inches of simmering water (being sure not to let the bottom of the bowl touch the water) and stir occasionally until the chocolate is melted and smooth. Remove the bowl from the saucepan and set aside to cool slightly, about 10 minutes. (You can also melt the chocolate in the microwave, heating it at about 20-second intervals and stirring periodically until it is melted and smooth.)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Whisk together the cocoa powder and hot water in a medium bowl until smooth.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Combine the cake flour, brown sugar, baking soda, baking powder, salt, ginger, cinnamon, nutmeg, and cloves in the bowl of an electric mixer fitted with the paddle attachment and begin mixing on medium-low speed. Add the butter, about 2 tablespoons at a time, increase the mixing speed to medium, and continue beating until the mixture resembles the texture of fine bread crumbs. Pour in the cocoa liquid and mix until combined. Add the vanilla extract and drop in the eggs, one at a time, beating until smooth and stopping once or twice to scrape the sides of the bowl. Pour in the molasses and the melted chocolate, increase the mixing speed to medium-high, and beat until smooth, about 30 seconds.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Pour the batter into the prepared pan and bake for about 55 minutes, or until a wooden skewer inserted in the center comes out clean (a few sticky crumbs are okay, too). Set the cake on a wire rack to cool almost completely in the pan.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Serve the gingerbread cut into squares and with the Vanilla Ice Cream, if desired.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }), _vm._v("In 1828, renowned cookery book author Eliza Leslie published what arguably became her most celebrated work, "), _c('em', [_vm._v("Seventy-Five Receipts for Pastry, Cakes, and Sweetmeats")]), _vm._v(". Three gingerbread recipes appear in this volume: Gingerbread Nuts, Common Gingerbread, and Lafayette Gingerbread. Typical of this period, Leslie included all of these recipes in her Cakes chapter. Only the Lafayette version, however, resembles modern-day cake, while the author instructed the others (cookies, really) to be rolled into balls and cut into shapes. My version of Lafayette gingerbread takes its cue from Miss Leslie’s. Robust and sweet with molasses and brown sugar; spicy with a good dose of ginger, cinnamon, allspice, and cloves; and bright with the freshness of lemon, this simple cake is moist and satisfying. Lafayette gingerbread is certainly elegant enough to serve plain. I do believe, however, Miss Leslie would have approved of accompanying squares of this dark cake with shiny, sugary preserved apricots and/or a drizzle of velvety crème anglaise.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "ch1.12"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/contents#ich1.12"
    }
  }, [_c('strong', [_vm._v("Eliza Leslie’s Lafayette Gingerbread")])])]), _vm._v(" "), _c('p', {
    staticClass: "subtitle1"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("MAKES ONE 9-INCH CAKE")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("2½ cups all-purpose flour")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("½ teaspoon salt")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("1 tablespoon ground ginger")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("2 teaspoons ground cinnamon")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("1 teaspoon ground allspice")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("1 teaspoon ground cloves")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("½ cup (1 stick) unsalted butter at room temperature")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("½ cup packed dark brown sugar")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("1 cup molasses")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("2 large eggs")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("2 teaspoons baking soda")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("1 cup hot water")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('strong', [_vm._v("Juice and grated zest of 1 lemon")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('strong', [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch05#page_118",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Preserved Apricots")]), _vm._v(" for serving (optional)"), _c('br'), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch07#page_133",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Crème Anglaise")]), _vm._v(" for serving (optional)")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Position a rack in the middle of the oven and preheat the oven to 350°F. Butter and flour a 9-by-3-inch springform pan.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Whisk together the flour, salt, ginger, cinnamon, allspice, and cloves in a large bowl.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Put the butter in the bowl of an electric mixer fitted with the paddle attachment and beat on medium-high speed until smooth. Add the brown sugar and beat until light and fluffy. Pour in the molasses and beat until smooth. Drop in the eggs, one at time, and mix until incorporated, stopping at least once to scrape the sides of the bowl. Dissolve the baking soda in the hot water in a small bowl. Reduce the mixing speed to medium-low and alternately incorporate the flour mixture and baking soda mixture, beginning and ending with the flour mixture and stopping once or twice to scrape the sides of the bowl. Add the lemon juice and zest and beat just until incorporated.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Pour the batter into the prepared pan and bake for about 45 minutes, or until the cake is dark chestnut brown in color, the top is cracked, and a wooden skewer inserted in the center comes out clean. Set the gingerbread on a wire rack to cool in the pan for about 10 minutes before turning out to cool for about 10 minutes more.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Serve the cake warm or at room temperature cut into squares and with the Preserved Apricots and/or a drizzle of the Crème Anglaise, if desired.")]), _vm._v(" "), _c('div', {
    staticClass: "boxb1"
  }, [_c('a', {
    attrs: {
      "id": "page_35"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Just exactly why Miss Leslie named this recipe for the Marquis de Lafayette isn’t entirely clear. We know that he made his third and final visit to America in 1824, staying for nearly a year and a half, and passing through a number of cities, including New York, Philadelphia, and Baltimore. Miss Leslie was no doubt aware of this, and perhaps his appearance had some influence on the recipes she was creating at the time.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Another theory proposes that Leslie’s recipe refers to an actual encounter between Lafayette and gingerbread. The colorful annals relating to George Washington’s mother, Mary Ball Washington, suggest that when the marquis visited her at her home on Charles Street in Fredericksburg, Virginia, she hosted him with a mint julep and gingerbread. Mrs. Washington had been living in town since moving from her farm in 1772. The marquis returned to America for a second time in 1780, so perhaps it was then that the president took him to visit his mother. Eliza Leslie was only a child at this time. Years later, though, during his third visit to America, he passed again through Fredericksburg, this time to pay respects to Mrs. Washington’s gravesite in 1825. Maybe Leslie learned of the gingerbread story then, and decided to add it to her collection of soon-to-be-published recipes.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("This gingerbread must have been rich and spicy indeed. For “A pound and a half of flour,” Miss Leslie called for “Five eggs … Half a pound of brown sugar … Half a pound of butter … A pint of sugar-house molasses … Four tablespoonfuls of ginger … Two large sticks of cinnamon … Three dozen grains of allspice … [and] Three dozen of cloves … powdered and sifted.” A good dose of lemon—“The juice and grated peel of two large lemons”—surely added a bit of refreshing tartness and moisture to the cake, which Miss Leslie noted was “the finest of all gingerbread.”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c1c385f8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch01.vue
// module id = 75
// module chunks = 0